import { getWobbleAnimation } from '@utils/animations';
import { useEffect } from 'react';
import {
  useAnimatedStyle,
  useSharedValue,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

export default function useExtensionWidgetAnimation() {
  const rotation = useSharedValue(0);
  const scale = useSharedValue(1);

  // Trigger animation
  useEffect(() => {
    const startAnimation = () => {
      rotation.value = getWobbleAnimation();

      scale.value = withSequence(
        withTiming(1.2, { duration: 500 }),
        withTiming(1, { duration: 500 }),
      );
    };

    const interval = setInterval(() => {
      startAnimation();
    }, 15000); // Repeat every 15 seconds

    startAnimation(); // Start animation immediately on mount

    return () => {
      clearInterval(interval);
    }; // Clear interval on unmount
  }, []);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [
      {
        rotateZ: `${rotation.value}deg`,
      },
      {
        scale: scale.value,
      },
    ],
  }));

  return { animatedStyle };
}
